








































































































































































import {
    defineComponent,
    inject,
    computed,
    ref,
    Ref,
    watch,
    onMounted,
} from '@vue/composition-api'
import axios from 'axios'

// Store
import {
    StoreKey as InputStoreKey,
    StoreType as InputStoreType,
} from '@/store/Input'
import {
    StoreKey as FormStoreKey,
    StoreType as FormStoreType,
} from '@/store/Form'
import {
    StoreKey as ErrorStoreKey,
    StoreType as ErrorStoreType,
} from '@/store/Error'
import {
    StoreKey as ValidatedStoreKey,
    StoreType as ValidatedStoreType,
} from '@/store/Validated'

// Components
import ErrorArea from '@/component/form/Error.vue'
import ShopList from '@/component/form/ShopList.vue'
import FieldName from '@/component/form/Field/Name.vue'
import FieldTel from '@/component/form/Field/Tel.vue'
import FieldEmail from '@/component/form/Field/Email.vue'
import FieldAddress from '@/component/form/Field/Address.vue'
import FieldConstruction from '@/component/form/Field/Construction.vue'
import HowtoList from '@/component/form/Howto/List.vue'
import FieldHowto from '@/component/form/Field/Howto.vue'
import FieldIpad from '@/component/form/Field/Ipad.vue'
import FieldShop from '@/component/form/Field/Shop.vue'
import FieldSchedule from '@/component/form/Field/Schedule.vue'
import FieldRequest from '@/component/form/Field/Request.vue'
import FieldQuestion from '@/component/form/Field/Question.vue'
import FieldImportant from '@/component/form/Field/Important.vue'
import Remaining from '@/component/form/Remaining.vue'
import PhoneModal from '@/component/form/Phone/Modal.vue'
import FieldFirstTime from '@/component/form/Field/FirstTime.vue'

// Util
import { enableBeforeUnload, disableBeforeUnload } from '@/ts/util/beforeUnload'

const useSubmitHandler = (
    formStore: FormStoreType,
    inputStore: InputStoreType,
    errorStore: ErrorStoreType,
    validatedStore: ValidatedStoreType,
    isLoading: Ref<boolean>,
    formWrap: Ref<HTMLElement | null>
) => {
    return async () => {
        isLoading.value = true
        errorStore.update({})

        const requestData = new FormData()

        requestData.append('form_id', inputStore.form_id.toString())
        requestData.append('name', inputStore.name)
        requestData.append('tel', inputStore.tel)
        requestData.append('email', inputStore.email)
        requestData.append('howto', inputStore.howto)
        requestData.append('zip', inputStore.zip)
        requestData.append('address', inputStore.address)
        requestData.append('construction', inputStore.construction)
        requestData.append('ipad', inputStore.ipad)
        requestData.append('shop', inputStore.shop)
        requestData.append('shop_other', inputStore.shop_other)
        requestData.append('date', inputStore.date)
        requestData.append('time', inputStore.time)
        requestData.append('first_time', inputStore.first_time)
        Object.keys(inputStore.question).map((key) => {
            const question = inputStore.question[key]
            if (question) {
                if (Array.isArray(question)) {
                    question.map((q) => {
                        requestData.append(
                            `question[${key}][${q.ordered}]`,
                            q.label
                        )
                    })
                } else {
                    requestData.append(`question[${key}]`, question)
                }
            }
        })
        Object.keys(inputStore.question_other).map((key) => {
            const questionOther = inputStore.question_other[key]
            if (questionOther) {
                Object.keys(questionOther).map((subKey) => {
                    const questionOtherDetail = questionOther[subKey]
                    if (questionOtherDetail) {
                        requestData.append(
                            `question_other[${key}][${subKey}]`,
                            questionOtherDetail
                        )
                    }
                })
            }
        })
        requestData.append('important', inputStore.important)
        requestData.append('request_type', inputStore.request_type + '')
        inputStore.requests.map((v) => {
            requestData.append('requests[]', v)
        })
        // requestData.append('request1', inputStore.request1)
        // requestData.append('request2', inputStore.request2)
        // requestData.append('request3', inputStore.request3)
        // requestData.append('request_model1', inputStore.request_model1)
        // requestData.append('request_model2', inputStore.request_model2)
        // requestData.append('request_model3', inputStore.request_model3)
        requestData.append('request_other', inputStore.request_other)
        if (inputStore.privacy) {
            requestData.append('privacy', '1')
        }
        requestData.append('referer', window.location.href)

        const response = await axios
            .post(`${formStore.base_path}/api/check`, requestData)
            .catch((e) => {
                console.log(e)
            })

        if (!response || typeof response.data !== 'object') {
            isLoading.value = false
            throw Error('Failed to post')
        }

        if (response.data.error) {
            validatedStore.is_open_panel = true
            isLoading.value = false
            errorStore.update(response.data.data)

            const target = (() => {
                if (errorStore.shop.value !== null) {
                    return document.querySelector('#_form_field_shop')
                }
                if (
                    errorStore.date.value !== null ||
                    errorStore.time.value !== null
                ) {
                    return document.querySelector('#_form_field_schedule')
                }
                if (errorStore.first_time.value !== null) {
                    return document.querySelector('#_form_field_first_time')
                }
                if (Object.keys(errorStore.question.value).length) {
                    return document.querySelector('#_form_field_question')
                }
                if (errorStore.howto.value !== null) {
                    return document.querySelector('#_form_field_howto')
                }
                if (errorStore.ipad.value !== null) {
                    return document.querySelector('#_form_field_ipad')
                }
                if (errorStore.name.value !== null) {
                    return document.querySelector('#_form_field_name')
                }
                if (errorStore.tel.value !== null) {
                    return document.querySelector('#_form_field_tel')
                }
                if (errorStore.email.value !== null) {
                    return document.querySelector('#_form_field_email')
                }
                if (errorStore.zip.value !== null) {
                    return document.querySelector('#_form_field_zip')
                }
                if (errorStore.address.value !== null) {
                    return document.querySelector('#_form_field_address')
                }
                if (errorStore.privacy.value !== null) {
                    return document.querySelector('#_form_field_privacy')
                }
                if (formWrap.value) {
                    return formWrap.value
                }
                return null
            })()

            if (target) {
                const rect = target.getBoundingClientRect()

                window.scrollTo({
                    top: rect.top + window.pageYOffset,
                    left: 0,
                    behavior: 'smooth',
                })
            }
            return
        }

        disableBeforeUnload()
        window.location.href = `${formStore.base_path}/confirm/${formStore.form_key}`
    }
}

export default defineComponent({
    components: {
        ErrorArea,
        FieldName,
        FieldTel,
        FieldEmail,
        FieldAddress,
        FieldConstruction,
        HowtoList,
        FieldHowto,
        FieldIpad,
        FieldShop,
        FieldSchedule,
        FieldRequest,
        FieldQuestion,
        FieldImportant,
        Remaining,
        ShopList,
        PhoneModal,
        FieldFirstTime,
    },
    setup(_, { root }) {
        const formStore = inject(FormStoreKey)
        if (!formStore) {
            throw new Error(`${FormStoreKey} is not provided`)
        }

        const inputStore = inject(InputStoreKey)
        if (!inputStore) {
            throw new Error(`${InputStoreKey} is not provided`)
        }

        const errorStore = inject(ErrorStoreKey)
        if (!errorStore) {
            throw new Error(`${ErrorStoreKey} is not provided`)
        }

        const validatedStore = inject(ValidatedStoreKey)
        if (!validatedStore) {
            throw new Error(`${ValidatedStoreKey} is not provided`)
        }

        const isLoading = ref<boolean>(false)
        const formWrap = ref<HTMLElement>(null)
        const stepNumber12 = computed(() => {
            if (formStore.shops.length > 0) {
                return 2
            }
            return 1
        })
        const stepNumber23 = computed(() => {
            if (formStore.howto.length > 0) {
                return 3
            }
            return 2
        })

        const submitHandler = useSubmitHandler(
            formStore,
            inputStore,
            errorStore,
            validatedStore,
            isLoading,
            formWrap
        )

        const privacyCheck = computed(() => {
            return inputStore.privacy
        })
        watch(privacyCheck, (newVal) => {
            validatedStore.privacy = newVal ? 1 : -1
        })

        const isFocused = ref(false)
        const remainingRef = ref(null)
        onMounted(() => {
            root.$nextTick(() => {
                if (!formWrap.value) {
                    return
                }
                const inputs = formWrap.value.querySelectorAll(
                    'input,select,textarea'
                )
                const nodes = Array.prototype.slice.call(inputs, 0) as Element[]
                nodes.forEach((elem) => {
                    elem.addEventListener('focus', () => {
                        if (!isFocused.value) {
                            enableBeforeUnload(formStore.before_unload_message)
                        }
                        isFocused.value = true
                    })
                })

                const url = new URL(window.location.href)
                if (url.searchParams.get('_mode') === 'back') {
                    const rect = formWrap.value.getBoundingClientRect()
                    window.scrollTo({
                        top: rect.top + window.pageYOffset,
                        left: 0,
                        behavior: 'smooth',
                    })
                }
            })
        })
        const remainingNumber = computed(() => {
            if (!remainingRef || !remainingRef.value) {
                return 1
            } else {
                return Number((remainingRef.value as any).remainingNumber)
            }
        })

        return {
            legend_chip: computed(() => {
                return root.$data.legend_chip ?? '当日もOK！'
            }),
            notification: computed(() => {
                return (
                    root.$data.notification ??
                    '必要事項をご入力の上、送信してください。<br class="u-pc-no" />担当より、折り返しご連絡致します。'
                )
            }),
            section_title01_label: computed(() => {
                return root.$data.section_title01_label ?? '展示場の選択'
            }),
            section_title01_desc: computed(() => {
                return (
                    root.$data.section_title01_desc ??
                    '※ご入力は１分程度で終了します'
                )
            }),
            section_title02_label: computed(() => {
                return root.$data.section_title02_label ?? 'お客さま情報の入力'
            }),
            section_title02_desc: computed(() => {
                return (
                    root.$data.section_title02_desc ??
                    '※ご入力は１分程度で終了します'
                )
            }),
            section_title02_note: computed(() => {
                return (
                    root.$data.section_title02_note ??
                    '携帯電話・スマートフォンのメールアドレスでお問い合わせ頂く場合、<br class="u-br-spno">PCメール受信拒否設定により返信がない可能性がございます。<br>予め「@asahigloval.co.jp」「@asahigloval.com」からのメールを受信できる様にご設定ください。'
                )
            }),
            section_title03_label: computed(() => {
                return root.$data.section_title03_label ?? 'ご相談方法の選択'
            }),
            section_title03_desc: computed(() => {
                return (
                    root.$data.section_title03_desc ??
                    '※ご入力は１分程度で終了します'
                )
            }),
            section_title04_label: computed(() => {
                return root.$data.section_title04_label ?? 'ご予約内容の入力'
            }),
            section_title04_desc: computed(() => {
                return (
                    root.$data.section_title04_desc ??
                    '※ご入力は１分程度で終了します'
                )
            }),
            section_privacy_title: computed(() => {
                return (
                    root.$data.section_privacy_title ??
                    '【プライバシーポリシーについて】'
                )
            }),
            section_privacy_desc: computed(() => {
                return root.$data.section_privacy_desc
                    ? root.$data.section_privacy_desc.replace(
                          'formStore.privacy',
                          formStore.privacy ?? ''
                      )
                    : `<a href="${
                          formStore.privacy ?? ''
                      }" target="_blank">プライバシーポリシー</a>に同意する`
            }),
            formStore,
            inputStore,
            errorStore,
            validatedStore,
            isLoading,
            formWrap,
            stepNumber12,
            stepNumber23,
            submitHandler,
            remainingRef,
            remainingNumber,
        }
    },
})
